<template>
  <div class="audit-main-box" v-loader.opacity="loading">

    <div class="no-results-box" v-if="alert.message">
      <BaseNoResults :title="alert.title" :text="alert.message"/>
    </div>

    <BaseTable class="no-border" v-if="tableAudit && !alert.message" :tabledata="tableAudit"/>

    <teleport :to="`#${slotPagination}`" v-if="isDataReady">
      <div v-if="tableAudit" class="align-items-center pagination-row">
        <p class="pagination-total">{{ `${tableAudit.total} ${$t("pagination.entries")}` }}</p>
          <BasePagination :total-pages="totalPages" :total="tableAudit.total" :is-loading="loading"
                          :per-page="perPage" :current-page="currentPage" @pagechanged="onPageChange"/>
      </div>
    </teleport>

    <teleport to="#settingsActionBar">
      <audit-filter @do-filter="fetchData"/>
    </teleport>
  </div>
</template>

<style lang="scss" scoped>
.audit-main-box {
  padding:                       10px;
}

.table {
  margin-bottom:                 0 !important;
}

@media (min-width: 992px) {
  .audit-main-box {
    overflow:                    hidden;
  }
}

@media (max-width: 991px) {
  .audit-main-box,
  .no-results-box {
    height:                      100%;
    text-align:                  center;
  }
}
</style>

<script>
import { useUserStore } from '@/store/user'
import AuditFilter from './AuditFilter.vue'

export default {
  name: 'AuditList',
  components: {
    AuditFilter,
  },
  data: () => ({
    loading: false,
    alert: {
      message: null,
      class: null
    },
    session: {
      collaborator: {},
      currentClinic: {}
    },
    tableAudit: {
      items: [],
      total: 0,
      columns: []
    },
    perPage: 20,
    currentPage: 1,
    totalPages: 0,
    filter: {
    },
    isDataReady: false,
    slotPagination: 'settingsPagination',
  }),
  mounted() {
    this.$activeLink.value = 'audit'

    const userStore = useUserStore()
    this.session = userStore.sessionInfo

    this.handleResize()
    window.addEventListener('resize', this.handleResize);

    this.currentPage > 1 ? this.fetchData(this.filter) : this.fetchData()
  },
  methods: {
    onPageChange(page) {
      this.currentPage = page;
      this.session.auditCurrentPage = page;
      this.filter.pagination = true
      this.filter.newRequest = false
      this.fetchData();
    },
    async fetchData(isFilter) {
      this.alert = {}

      if (isFilter) {
        this.filter = isFilter;
        this.filter.statusFilter = isFilter.filterSelected

        if (!isFilter.pagination)
        this.currentPage = this.session.auditCurrentPage ? this.session.auditCurrentPage : 1;

        if (isFilter.newRequest) {
          this.session.auditCurrentPage = 1
          this.currentPage = 1
        }
      }

      this.filter.page = this.currentPage

      this.loading = true
      NProgress.start()
      try {
        let response = await this.$auditService.getList(this.filter)

        this.tableAudit = {
          'items': response.result.audits,
          'total': response.result.meta.paginate.totalCount,
          'columns': [
            {name: this.$i18n.t('audit.entry'), type: 'string', value: 'createdAt', width: '20%'},
            {name: this.$i18n.t('audit.action'), type: 'string', value: 'action', width: '20%'},
            {name: this.$i18n.t('audit.agent'), type: 'string', value: 'agent', width: '20%'},
            {name: this.$i18n.t('audit.agentType'), type: 'string', value: 'agentType', width: '20%'},
            {name: this.$i18n.t('audit.message'), type: 'string', value: 'message', width: '20%'},
          ]
        };

        this.totalPages = Math.ceil(response.result.meta.paginate.totalCount / this.perPage);

        if (response.result.meta.paginate.totalCount === 0) {
          this.tableAudit = {items: [], total: 0, columns: []};
          this.totalPages = 1
          // this.alert = this.$message.alert(this, 'request_notfound', 'warning')
          this.alert = this.$message.alertWithTitle(this, 'request_notfound_title', 'request_notfound_text')
          // this.$message.popup(this, 'request_notfound', 'operationWarning', 'warn')
        }
      } catch (err) {
        this.$message.popup(this, 'request_error', 'operationFail', 'error')
        // this.alert = this.$message.alert(this, 'request_error', 'danger')
      } finally {
        NProgress.done(true);
        this.loading = false
        this.isDataReady = true
      }
    },
    handleResize() {
      this.slotPagination = window.innerWidth > 767 ? 'settingsPagination' : 'settingsPaginationMobile'
    },
  },
  unmounted() {
    window.removeEventListener('resize', this.handleResize);
  },
}
</script>
